import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { Suspense } from 'react'

import Image from '@/components/Atoms/Image/Image'
import ProductInfo from '@/components/Feed/ProductInfo/ProductInfo'
import TableColumnFilter from '@/components/Filters/TableColumnFilter/TableColumnFilter'
import type {
  AntdTreeType,
  CategoryInterface,
  NomenclatureEditorFeedProductInterface,
  NomenclatureGroupInterface,
} from '@/types'
import { safeLazy } from '@/utils/app/safeLazy'

import cn from './NomenclatureEditorFeed.module.scss'

const NomenclatureEditModal = safeLazy(
  () =>
    import(
      '@/components/EntityEditModals/NomenclatureEditModal/NomenclatureEditModal'
    )
)

const columnHelper =
  createColumnHelper<NomenclatureEditorFeedProductInterface>()

export const getTanstackColumns = (params: {
  categoriesTree: CategoryInterface[]
  antdCategoriesTree: AntdTreeType[]
  nomenclatureGroupsTree: NomenclatureGroupInterface[]
  antdNomenclatureGroupsTree: AntdTreeType[]
}): ColumnDef<NomenclatureEditorFeedProductInterface, unknown>[] => {
  return [
    columnHelper.display({
      id: 'nomenclatureEditModal',
      header: '',
      cell: (info) => (
        <Suspense fallback={null}>
          <NomenclatureEditModal
            nomenclature={info.row.original}
            categoriesTree={params.categoriesTree}
            antdCategoriesTree={params.antdCategoriesTree}
            nomenclatureGroupsTree={params.nomenclatureGroupsTree}
            antdNomenclatureGroupsTree={params.antdNomenclatureGroupsTree}
          />
        </Suspense>
      ),
    }),
    columnHelper.display({
      id: 'productInfo',
      header: '',
      cell: (info) => (
        <ProductInfo product={info.row.original.nomenclatureDto} />
      ),
    }),
    columnHelper.display({
      id: 'productImages',
      header: 'Фото',
      cell: (info) => (
        <div className={cn.imageBlock}>
          <Image productCode={info.row.original.nomenclatureDto.code} />
        </div>
      ),
    }),
    columnHelper.display({
      id: 'parentGroup',
      header: 'Группа номенклатур',
      cell: (info) => (
        <span>
          {info.row.original.nomenclatureDto.parentModel?.description || ''}
        </span>
      ),
    }),
    columnHelper.display({
      id: 'productArt',
      header: 'Артикул',
      cell: (info) => info.row.original.nomenclatureDto.article,
    }),
    columnHelper.display({
      id: 'productName',
      header: 'Наименование',
      cell: (info) => info.row.original.nomenclatureDto.description,
    }),
    // columnHelper.accessor((row) => row.nomenclatureDto.brandDto?.description, {
    //   id: 'brand',
    //   header: 'Бренд',
    //   cell: (info) => <span>{info.getValue() || ''}</span>,
    // }),
    columnHelper.display({
      id: 'brand',
      header: () => <TableColumnFilter title="Бренд" filterType="brands" />,
      cell: (info) => (
        <span>
          {info.row.original.nomenclatureDto.brandDto?.description || ''}
        </span>
      ),
    }),
    columnHelper.display({
      id: 'country',
      header: 'Страна',
      cell: (info) => (
        <span>
          {info.row.original.nomenclatureDto.countryDto?.description || ''}
        </span>
      ),
    }),
  ]
}

// Конфигурация пропорций колонок (Grid Template)
export const EDITOR_COLUMN_WIDTHS: Record<string, string> = {
  nomenclatureEditModal: '40px',
  productInfo: '40px',
  productImages: '100px',
  parentGroup: 'minmax(150px, 1fr)',
  productArt: 'minmax(100px, 0.8fr)',
  productName: 'minmax(250px, 2fr)',
  brand: 'minmax(120px, 1fr)',
  country: 'minmax(100px, 0.8fr)',
}
